import {AxiosResponse} from 'axios';
import {ExternalAccountType} from '../backend/enums/external-account-type';
import {ExternalAccount} from '../backend/interfaces/external-account';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class ExternalAccountsRepository {
  // Singleton Instance
  private static _instance: ExternalAccountsRepository;

  // Private
  private logger: Logger;

  static get instance(): ExternalAccountsRepository {
    if (!this._instance) {
      this._instance = new ExternalAccountsRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('ExternalAccountsRepository');
  }

  // Get all external accounts of a user, fully decrypted (System Administrator only)
  public async getForUser(userId: string): Promise<Array<ExternalAccount<any>>> {
    const response: AxiosResponse<Array<ExternalAccount<any>>> =
      await BackendApiManager.instance.get<Array<ExternalAccount<any>>>(
        `/users/${userId}/external-accounts`
      );

    return response.data;
  }

  // Create a new external account of a given type for a user (System Administrator only)
  public async create(userId: string, type: ExternalAccountType): Promise<ExternalAccount<any>> {
    const response: AxiosResponse<ExternalAccount<any>> = await BackendApiManager.instance.post<
      ExternalAccount<any>
    >(`/users/${userId}/external-accounts/${type}`, undefined);

    return response.data;
  }

  // Delete the external account of a given type of a user (System Administrator only)
  public async delete(userId: string, type: ExternalAccountType): Promise<void> {
    await BackendApiManager.instance.delete<void>(`/users/${userId}/external-accounts/${type}`);
  }
}
